// extracted by mini-css-extract-plugin
export default {"quizImage":"QuizImage_quizImage__gQPhm","quizImage__image":"QuizImage_quizImage__image__5mbET","quizImage__checkBox":"QuizImage_quizImage__checkBox__SFZO7"};